import { SKY_WORLD } from './86-sky-world-scale.mjs';
import {
  skyFlightFrame,
  skyFlightVectorToLocal,
  skyFlightVectorToWorld,
} from './92-sky-flight-frame.mjs';

/** Resolve a measured physical barrel offset into world metres for this fixed
 * step. Geometry is injected as data; policy never reads a renderer. Samples
 * older than100ms, future samples, invalid barrels and out-of-reach offsets
 * use the explicit centred fallback. With a valid flightFrame, measurements
 * remain world-relative offsets but anatomical bounds are checked in its local
 * axes; fallback offsets rotate from the actual pilot position. Invalid frames
 * retain legacy world-axis behavior. A projectile keeps this origin forever.
 * Protected traversal never accepts combat geometry. */
export function skyWeaponMuzzle(state, sample, barrel, count) {
  const point = sample?.barrels?.[barrel];
  const frame = skyFlightFrame(state.flightFrame);
  const local = frame ? skyFlightVectorToLocal(frame, point) : point;
  const age = state.time - sample?.time;
  const measured =
    !state.traversal &&
    Number.isFinite(age) &&
    age >= -1e-8 &&
    age <= 0.1 &&
    local &&
    [local.x, local.y, local.z].every(Number.isFinite) &&
    Math.abs(local.x) <= 1.2 &&
    Math.abs(local.y) <= 1.4 &&
    local.z >= -2 &&
    local.z <= 0.8 &&
    Math.hypot(local.x, local.y, local.z) <= 2;
  const fallback = { x: count === 2 ? (barrel ? 0.16 : -0.16) : 0, y: 0, z: -SKY_WORLD.pilotZ };
  const offset = frame ? skyFlightVectorToWorld(frame, fallback) : fallback;
  return measured
    ? {
        x: state.x + point.x,
        y: state.y + point.y,
        z: (state.pilotZ ?? SKY_WORLD.pilotZ) + point.z,
        source: 'measured',
      }
    : {
        x: state.x + offset.x,
        y: state.y + offset.y,
        z: frame ? (state.pilotZ ?? SKY_WORLD.pilotZ) + offset.z : 0,
        source: 'fallback',
      };
}
